export const version = "web/5.5.1";
//# sourceMappingURL=_version.js.map